import { TreeCardObject } from '../tree-card/tree-card-object.model';
import { StringUtils } from 'src/app/services/utils/string.utils';
import { ProductStatusObject } from '../product-status-object.model';
import { ProductTypeObject } from '../product-type-object.model';

export class ProductObject extends TreeCardObject {

  constructor(name: string, completed: boolean, crmId: string, operation: string,
    status: string, dependencies: boolean, index: number, productId: string, specId: string) {
    super(name, 'PRODUCTO', StringUtils.NOT_AVALIABLE, completed, crmId, operation,
      ProductStatusObject.createWithStatus(status), dependencies, 1, index, productId, specId, ProductTypeObject.PRODUCT);
    return this;
  }
}
